import React, { useEffect, useState } from "react";
import "./book-appointment.scss";
import Avatar from "../../../base/Avatar/Avatar";
import { Typography } from "src/latest/src/components";
import { getSlotIcons, stringToObject } from "../../../../legacy/utils/helpers";
import { Radio, Space } from "antd";
import AppButton from "../../../base/Button/Button";
import { getPicture } from "../../../../redux/services/commonServices";
import moment from "moment";
import { clearModalContent } from "src/redux/modules/modalEvent";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "../../../base/Tooltip/Tooltip";
import { getServiceTypeFromFilterForSlot } from "src/latest/src/utils";
import { TimeZoneAbbreviated } from "src/latest/src";
import { getSlotDetials } from "src/latest/src/utils/AvailabilityWidgetUtils";

type Props = {
    item: Object,
    slot: Object,
    handleConfirmMatching: any,
    clientId: String,
    avialbleSlotDetails: Object,
    selectedFilters: Object,
    isClinicianAvailabilityPage?: boolean
}; 

function BookAppointment({
    item,
    slot,
    handleConfirmMatching,
    clientId,
    avialbleSlotDetails,
    selectedFilters,
    isClinicianAvailabilityPage,
}: Props) {
    const [intake, setIntake] = useState("");
    const officeData = item?.other_data?.therapist_practice_address_info
       ? stringToObject(item.other_data.therapist_practice_address_info)
       : {};

    const [imgUri, setImgUri] = useState("");
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [selectedService, setSelectedService] = useState();
    const [slotRenderDetails, setSlotRenderDetails] = useState();
    const serviceType = useSelector(
        (state) =>
            state?.questionnaireData?.currentConfig?.combinedFilters
                ?.schedule_request?.service_type
    );
    const dispatch = useDispatch();

    const { practiceTimeZone, practiceTimeZoneKey, tenantContact } = useSelector(
        (state: any) => state?.configuration
    );

    useEffect(() => {
        getImageUri();
    }, []);

    useEffect(() => {
        if (selectedFilters?.filters) {
            const selectedService = getServiceTypeFromFilterForSlot(selectedFilters, serviceType);

            setSelectedService(selectedService);
            getSlotDetials(selectedService,setSlotRenderDetails);
        }
    }, [selectedFilters]);

    const getImageUri = async () => {
        
        const officeImageUrl = officeData?.officeImage; 

        if (officeImageUrl) {
            try {
                const decodedUrl = decodeURIComponent(officeImageUrl);

                if (decodedUrl && (decodedUrl.startsWith('http://') || decodedUrl.startsWith('https://'))) {
                    setImgUri(officeImageUrl);

                    return;
                }
            } catch(error) {
                console.error('Failed to decode officeImage URL:', error);
            }
        }

        const imageData =
            Object.entries(officeData).length !== 0 &&
            (await getPicture(officeData?.img));

        // Sets the base64 string to state
        setImgUri(imageData);
    };

    const selectedIntake = (e) => {
        setIntake(e.target.value);
    };

    const handleClick = () => {
        dispatch(clearModalContent());
    };

 

    const confirmBooking = (
        item,
        slot,
        clientId,
        intake,
        avialbleSlotDetails
    ) => {
        if (buttonDisabled === false) {
            setButtonDisabled(true);
            handleConfirmMatching(
                item,
                slot,
                clientId,
                intake,
                avialbleSlotDetails
            );
        }
    };

    return (
        <div className="book-appointments-match-modal ">
            <div className="match-confirm d-flex">
                <div className="d-flex flex-row ms-auto me-auto mb-5 profile-match-score-container">
                    <div className="d-flex flex-column align-items-center">
                        <Avatar
                            photoUrl={item.profile_picture}
                            fullName={item.therapist_name}
                            size="120px"
                            className="mb-3"
                        />
                        <div
                            style={{ display: "none" }}
                            className=" desktop-name-container"
                        >
                            <div
                                className="d-flex"
                                style={{ marginLeft: "5px" }}
                            >
                                <div>
                                    <Tooltip
                                        text={item.therapist_name}
                                        placement="bottom"
                                        className="reviewpagetip"
                                    >
                                        <Typography
                                            variant="size-16"
                                            weight="black"
                                            color=""
                                        >
                                            {item.therapist_name.length > 21
                                                ? `${item.therapist_name.substring(
                                                      0,
                                                      18
                                                  )}...`
                                                : item.therapist_name}
                                        </Typography>
                                    </Tooltip>
                                </div>
                                <div style={{ marginLeft: "2px" }}>
                                    <Typography>
                                        {item.therapist_pronoun}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{ display: "none" }}
                            className="mobile-name-container"
                        >
                            <div
                                className="d-flex"
                                style={{ marginLeft: "11px" }}
                            >
                                <div>
                                    {" "}
                                    <Typography
                                        variant="size-16"
                                        weight="black"
                                        color=""
                                    >
                                        {item.therapist_name}
                                    </Typography>
                                </div>
                                <div style={{ marginLeft: "2px" }}>
                                    <Typography>
                                        {item.therapist_pronoun}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div />
            </div>
            <div className="book-appointment__therapy-section">
                <div>
                    <div
                        className="d-inline-flex mb-0 justify-content-center align-items-center "
                        style={{
                            backgroundImage: `${slotRenderDetails?.background}`,
                            height: "65px",
                            width: "65px",
                            borderRadius: "50%",
                            margin: "auto 4px",
                            padding: "5px",
                            border: " 2.54px solid rgba(255,255,255,0.8)",
                            position: "relative",
                            bottom: "33px",
                            boxShadow: "0 4px 11px 0 rgba(51,177,139,0.15)",
                        }}
                    >
                        <img
                            src={slotRenderDetails?.icon}
                            style={{
                                maxWidth: `${
                                    selectedService?.label === "Psychiatry"
                                        ? "60%"
                                        : selectedService?.label ===
                                          "Assessment"
                                        ? "71%"
                                        : "100%"
                                }`,
                            }}
                            alt="Therapy Icon"
                        />
                    </div>
                    <div style={{ position: "relative", bottom: "20px" }}>
                        <Typography variant="size-16" weight="black" color="">
                            {selectedService?.label}
                        </Typography>
                    </div>
                    <div className="mt-4">
                        <Typography
                            variant="size-18"
                            weight="bold"
                            color="color-2"
                        >
                            {isClinicianAvailabilityPage && practiceTimeZone
                                ? `${moment(slot?.slot?.slot_start_date_time)
                                      .tz(practiceTimeZone)
                                      .format("dddd, MMM D • h:mm A")}`
                                : `${moment(
                                      slot?.slot?.slot_start_date_time
                                  ).format("dddd, MMMM, D • h:mm A")}`}
                            {isClinicianAvailabilityPage && practiceTimeZone
                                ? ` (${practiceTimeZoneKey})`
                                : ` (${TimeZoneAbbreviated(
                                      slot?.slot?.slot_start_date_time
                                  )})`}
                        </Typography>
                    </div>
                    <div className="d-inline-flex mt-4 mb-4">
                        <span className="me-2">
                            {getSlotIcons(slot.slot.slot_reason_type)}
                        </span>{" "}
                        <Typography variant="size-18" color="color-2">
                            {slot.slot.meeting_pref.replace(/<[^>]*>/g, " ")}
                        </Typography>
                    </div>
                    {slot.slot.tool_tip
                        .replace(/<[^>]*>/g, "")
                        ?.toLowerCase()
                        ?.includes("online or in person") && (
                        <div>
                            <div className="popover-inner-content">
                                <div className="mt-3 mb-3">
                                    <Radio.Group
                                        onChange={(e) => {
                                            selectedIntake(e);
                                        }}
                                        value={intake}
                                        size="large"
                                    >
                                        <Space direction="horizontal">
                                            (
                                            <>
                                                <Radio value="INTAKE_IN_PERSON">
                                                    In-Person Meeting
                                                </Radio>
                                                <Radio value="INTAKE_ONLINE">
                                                    Online Meeting
                                                </Radio>
                                            </>
                                            )
                                        </Space>
                                    </Radio.Group>
                                </div>
                            </div>
                        </div>
                    )}
                    {((slot.slot.tool_tip
                        .replace(/<[^>]*>/g, "")
                        ?.toLowerCase()
                        ?.includes("person") &&
                        !slot.slot.tool_tip
                            .replace(/<[^>]*>/g, "")
                            ?.toLowerCase()
                            ?.includes("online or in person")) ||
                        (slot.slot.tool_tip
                            ?.replace(/<[^>]*>/g, "")
                            ?.toLowerCase()
                            ?.includes("online or in person") &&
                            intake === "INTAKE_IN_PERSON")) && (
                        <div
                            className="office-location"
                            style={{
                                height: "178px",
                                width: "299px",
                                borderRadius: "10px",
                                backgroundColor: "#FFFFFF",
                                boxShadow: "0 22px 44px 0 rgba(0, 0, 0, 0.06)",
                                margin: "30px auto",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <Typography
                                variant="size-14"
                                weight="bold"
                                color="color-28"
                                className=" mt-2 mb-3"
                                style={{ position: "relative", top: "15px" }}
                            >
                                {" "}
                                THERAPIST'S IN-PERSON OFFICE
                            </Typography>
                            <div className="d-flex flex-row mt-4">
                                {Object.entries(officeData).length > 0 && (
                                    <div className="d-flex align-items-center ms-5 me-1">
                                        <Avatar
                                            photoUrl={imgUri}
                                            fullName={item?.therapy_location[0]}
                                            size="76px"
                                            className="mb-1"
                                        />
                                    </div>
                                )}
                                <div
                                    className="d-flex align-items-center m-auto flex-column"
                                    style={{ width: "40%" }}
                                >
                                    <Typography variant="size-14" weight="bold">
                                        {item.therapy_location}
                                    </Typography>
                                    <Typography
                                        variant="size-14"
                                        className="mt-2"
                                    >
                                        {Object.entries(officeData).length >
                                            0 &&
                                            officeData?.addressInfo1.replace(
                                                /<[^>]*>/g,
                                                ""
                                            ) +
                                                " " +
                                                officeData?.addressInfo2.replace(
                                                    /<[^>]*>/g,
                                                    ""
                                                ) +
                                                " " +
                                                officeData?.addressInfo3.replace(
                                                    /<[^>]*>/g,
                                                    ""
                                                )}
                                    </Typography>
                                </div>
                            </div>
                            {Object.entries(officeData).length === 0 && (
                                <Typography variant="size-14" className="m-4">
                                    Office address not available. Please call
                                    for more information: {tenantContact}
                                </Typography>
                            )}
                        </div>
                    )}
                    <br />
                    <AppButton
                        label={"Continue"}
                        className="Booking-continue-button"
                        onClick={() => {
                            confirmBooking(
                                item,
                                slot,
                                clientId,
                                intake,
                                avialbleSlotDetails
                            );
                        }}
                        disabled={
                            (slot.slot.tool_tip
                                ?.replace(/<[^>]*>/g, "")
                                .toLowerCase()
                                ?.includes("online or in person") &&
                                intake === "") ||
                            buttonDisabled
                        }
                    />
                </div>
                <div className="review-back-button">
                    <FontAwesomeIcon
                        icon={faArrowLeftLong}
                        className="review-arrow-left ms-2 mt-1"
                        size="sm"
                    />

                    <button
                        onClick={handleClick}
                        className=" ChooseBack btn btn-transparent"
                    >
                        Choose a different Appointment
                    </button>
                </div>
            </div>
        </div>
    );
}

export default BookAppointment;
